// extracted by mini-css-extract-plugin
export default {"tags":"articleSearchTagField_tags__Sa8Gn","tag":"articleSearchTagField_tag__cTTE4","closeIcon":"articleSearchTagField_closeIcon__69GmO"};